import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { route } from '~/app/helpers/route';
import usePageTitle from '~/app/hooks/usePageTitle';
import useTranslation from '~/app/hooks/useTranslation';
import { useAppHeader } from '~/app/modules/appHeader';
import { Machine } from '~/types';
import { useStoreState } from '~/store';
import List from './List';
import Header from '~/issueService/Header';
import EmptyMessage from '~/issueService/EmptyMessage';
import { ROUTES } from "~/app/Router";
import { IssueOrServiceType } from '~/app/data/statuses/chat';
import { TASK_ROUTES } from '~/tasks/Router';

type ServiceProps = {
    fromTask?: boolean;
};
export type ServiceComponent = React.VFC<ServiceProps>;

const Services: ServiceComponent = ({ fromTask = false }) => {
    const { id } = useParams<{ id: Machine['id'] }>();

    const { t } = useTranslation('machine.details');

    usePageTitle(t('serviceStatus'));
    const history = useHistory();
    const { setData } = useAppHeader();

    const machine = useStoreState(state => state.machine.data);
    const services = useStoreState(state => state.service.filteredServices);
 
    usePageTitle(fromTask ? (machine.name || '').toUpperCase() : t('serviceStatus'));

    useEffect(() => {
        setData({
            title: fromTask ? (machine.name || '').toUpperCase() : t('serviceStatus'),
            subTitle: `${machine.intern} - ${machine.name}`.toUpperCase(),
            backLink: fromTask ? route(TASK_ROUTES.list) : (history.length > 1 ? history.goBack : route(ROUTES.projects)),
            showUser: false,
            machineId: '',
            projectId: '',
            showMachineMessages: false,
            isIssueDetailPage: false,
            isServiceDetailPage: false,
            notification: false,
            search: false
        });
    }, [setData, id, machine, t, history, fromTask]);

    return (
        <>
            {!fromTask && <Header type={IssueOrServiceType.SERVICE} />}
            {services.length ? <List list={services} /> : <EmptyMessage type={IssueOrServiceType.SERVICE} />}
        </>
    );
};
export default Services;
